// src/App.js
import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Accueil from "./pages/Accueil";
import Manifeste from "./pages/Manifeste";
import Programmation from "./pages/Programmation";
import { LanguageProvider } from "./i18n/LanguageProvider"; // <-- import nommé

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Accueil} />
          <Route path="/Manifeste" component={Manifeste} />
          <Route path="/Programmation" component={Programmation} />
        </Switch>
      </BrowserRouter>
    </LanguageProvider>
  );
}
